"use strict";

var scrollAnimate = require("./scrollAnimate");

/**
 * @function
 * @description function to init footer events
 */
const initFooterEvents = () => {
    const $backToTop = $(".back-to-top");
    const $userActive = $(".user-active");
    const $guestOrderLink = $(".guest-order-link");
    const $guestCheckoutEnabled = $(".guest-user-enabled");

    if ($backToTop.length) {
        $backToTop.on("click", () => {
            scrollAnimate();
        });
    }

    if ($guestCheckoutEnabled.length < 1 || ($userActive.length && $guestOrderLink.length)) {
        $guestOrderLink.hide();
    }
};

module.exports = initFooterEvents;
